// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1435":"d2cb75c0","2249":"110c9733","2291":"0051270d","2589":"d6fdf0fb","8401":"d2cb75c0"}[chunkId] + ".css";
};